import { Fragment } from 'react';
import { filasParte, pieParte, type ParteOdoo as Parte } from '@/lib/llamadas/parte';

// Tarjeta del parte creado en Odoo, debajo de la línea de tiempo. Enseña la foto
// que dejó el escritor del parte al crearlo (ver `lib/llamadas/parte.ts`); la
// lógica de qué filas salen vive allí, esto solo las pinta.
export function ParteOdoo({ parte }: { parte: Parte }) {
  const filas = filasParte(parte);
  const pie = pieParte(parte);

  return (
    <section
      data-testid="parte-odoo"
      aria-label={`Parte en Odoo nº ${parte.id_odoo}`}
      className="mt-2.5 rounded-[var(--radius-sm)] border border-[var(--border)] bg-[var(--surface-2)] px-3 py-2.5"
    >
      <div className="flex items-baseline justify-between gap-3">
        <p className="m-0 shrink-0 text-[10.5px] font-semibold uppercase tabular-nums tracking-wider text-[var(--text-dim)]">
          Parte en Odoo · nº {parte.id_odoo}
        </p>
        {parte.etapa && (
          <span className="mono min-w-0 break-words text-right text-[11px] font-semibold text-[var(--navy)]">
            {parte.etapa}
          </span>
        )}
      </div>
      {parte.titulo && (
        <p className="m-0 mt-1 break-words text-[12.5px] font-medium text-[var(--navy)]">
          {parte.titulo}
        </p>
      )}
      {filas.length > 0 && (
        <dl className="m-0 mt-2 grid grid-cols-[max-content_minmax(0,1fr)] gap-x-3 gap-y-1 text-[11.5px] tabular-nums">
          {filas.map((f) => (
            <Fragment key={f.etiqueta}>
              <dt className="text-[var(--text-dim)]">{f.etiqueta}</dt>
              <dd className="m-0 min-w-0 break-words text-[var(--text-2)]">{f.valor}</dd>
            </Fragment>
          ))}
        </dl>
      )}
      {pie && <p className="m-0 mt-2 text-[11px] text-[var(--text-dim)]">{pie}</p>}
    </section>
  );
}
